import React from 'react'
import { Typography } from '@mui/material'
import { Link, useLocation } from 'react-router-dom'
import Wrapper from '@app/components/Common/Wrapper/Wrapper'
import { RoomsDeviceIcon } from 'icons'
import useStyles from './RoomsButton.style'

const RoomsButton: React.FC = () => {
  const { classes } = useStyles()
  const location = useLocation()
  return (
    <Wrapper className={classes.deviceSettingsContainer}>
      <Link
        to={`${location.pathname}/rooms`}
      >
        <Wrapper className={classes.deviceSettingsItem}>
          <Wrapper className={classes.deviceSettingsIcon}>
            <RoomsDeviceIcon />
          </Wrapper>
          <Typography className={classes.deviceSettingsLabel}>Rooms</Typography>
        </Wrapper>
      </Link>
    </Wrapper>
  )
}

export default RoomsButton
